import { API } from '@/api/Api'
import {
  FindNIIAnalysis,
  FindInternalThresholds,
  FindSummaryData,
  FindExtremeEvents,
  FindHistoricalData,
  FindSimulationData,
  UpdateExtremeEventsMutation,
  CalculateExtremePeriod
} from '@/api/query/NII.graphql'

export default {
  // Queries
  async FindNIIAnalysis (accountId) {
    const Data = { accountId: accountId }
    return await API.GQLRequest(FindNIIAnalysis, Data)
  },

  async FindInternalThresholds (accountId, analysisId) {
    const Data = { accountId: accountId }

    // Only add analysisId if it's provided
    if (analysisId) {
      Data.analysisId = analysisId
    }

    return await API.GQLRequest(FindInternalThresholds, Data)
  },

  async FindSummaryData (accountId, analysisId) {
    const Data = { accountId: accountId }

    // Only add analysisId if it's provided
    if (analysisId) {
      Data.analysisId = analysisId
    }

    return await API.GQLRequest(FindSummaryData, Data)
  },

  async FindExtremeEvents (accountId, analysisId) {
    const Data = { accountId: accountId }

    // Only add analysisId if it's provided
    if (analysisId) {
      Data.analysisId = analysisId
    }

    return await API.GQLRequest(FindExtremeEvents, Data)
  },

  async FindHistoricalData (accountId, analysisId) {
    const Data = { accountId: accountId }

    // Only add analysisId if it's provided
    if (analysisId) {
      Data.analysisId = analysisId
    }

    return await API.GQLRequest(FindHistoricalData, Data)
  },

  async FindSimulationData (accountId, analysisId) {
    const Data = { accountId: accountId }

    // Only add analysisId if it's provided
    if (analysisId) {
      Data.analysisId = analysisId
    }

    return await API.GQLRequest(FindSimulationData, Data)
  },

  async UpdateExtremeEvents (options) {
    return await API.GQLRequest(UpdateExtremeEventsMutation, options)
  },

  async CalculateExtremePeriod (niiAnalysisId, periodType, riskType) {
    const Data = {
      niiAnalysisId: niiAnalysisId,
      periodType   : periodType,
      riskType     : riskType
    }

    return await API.GQLRequest(CalculateExtremePeriod, Data)
  }
}
